import type { IScope } from "angular";
import { finalize } from "rxjs/operators";

import type { IEquipmentFunctionalityTypeSlim, IResponseWithLoading } from "App/Modules/Models";
import { EquipmentFunctionalityClass } from "App/Modules/Models";
import type { IEquipmentFunctionalityTypesRepository } from "App/Modules/Repositories";
import { extendWithLoadingAndFail } from "App/Modules/Services";

export default class EquipmentFunctionalityTypeComponentController {
    public static $inject: string[] = ["$scope", "irEquipmentFunctionalityTypesRepository"];

    public functionalityTypeId: string;

    public equipmentFunctionalityType: IResponseWithLoading<IEquipmentFunctionalityTypeSlim>;

    constructor(
        private readonly $scope: IScope,
        private readonly equipmentFunctionalityTypesRepository: IEquipmentFunctionalityTypesRepository,
    ) {}

    public $onInit() {
        this.equipmentFunctionalityType = { isLoading: true };

        extendWithLoadingAndFail(
            this.equipmentFunctionalityTypesRepository.getFunctionalityType(this.functionalityTypeId),
        )
            .pipe(finalize(() => this.$scope.$applyAsync()))
            .subscribe(
                (response: IResponseWithLoading<IEquipmentFunctionalityTypeSlim>) => {
                    this.equipmentFunctionalityType = response;
                },
                (error) => {
                    this.equipmentFunctionalityType = error;
                },
            );
    }

    public isVideo() {
        return (
            this.equipmentFunctionalityType.data &&
            this.equipmentFunctionalityType.data.class === EquipmentFunctionalityClass.Video
        );
    }

    public isIO() {
        return (
            this.equipmentFunctionalityType.data &&
            this.equipmentFunctionalityType.data.class === EquipmentFunctionalityClass.IO
        );
    }
}
